import {onlyItem} from '../../../../../../../shared/helpers/src/utilities/arrayHelpers';

/*
 * Helpers.
 */

export function computeBulkSelectedValues(
  currentId: number,
  lastSelectedId: number | undefined,
  ids: ReadonlyArray<number>,
) {
  if (!lastSelectedId) {
    return [];
  }
  const currentIndex = ids.indexOf(currentId);
  const previousIndex = ids.indexOf(lastSelectedId);

  if (currentIndex < previousIndex) {
    return ids.slice(currentIndex, previousIndex);
  }
  return ids.slice(previousIndex, currentIndex + 1);
}

export function computeIsSiblingSelected(itemIds: ReadonlyArray<number>, siblingItemId?: number) {
  if (!siblingItemId) {
    return false;
  }
  return itemIds.includes(siblingItemId);
}

export function computeNextSelectedItemId(
  itemIds: ReadonlyArray<number>,
  selectedItemIds: ReadonlyArray<number>,
) {
  const selectedItemId = onlyItem(selectedItemIds);
  if (!selectedItemId) {
    return undefined;
  }
  const indexOfSelected = itemIds.indexOf(selectedItemId);

  // If we are at the end of the list, we can return the current item.
  if (itemIds.length <= indexOfSelected + 1) {
    return undefined;
  }
  return itemIds[indexOfSelected + 1];
}

export function computePreviousSelectedItemId(
  itemIds: ReadonlyArray<number>,
  selectedItemIds: ReadonlyArray<number>,
) {
  const selectedItemId = onlyItem(selectedItemIds);
  if (!selectedItemId) {
    return undefined;
  }
  const indexOfSelected = itemIds.indexOf(selectedItemId);

  // If we are at the start of the list, we can return the current item.
  if (indexOfSelected === 0) {
    return undefined;
  }
  return itemIds[indexOfSelected - 1];
}
